import { render, staticRenderFns } from "./PurchaseTotalCreditNoteNumberDisplayer.vue?vue&type=template&id=49615edd"
import script from "./PurchaseTotalCreditNoteNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./PurchaseTotalCreditNoteNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports